// Component: Textarea.jsx
// Purpose: DS multiline input — `.ds-input.ds-textarea` (auto height, min 64px,
//   vertical resize). Same field wrapper (label/hint/error) as Input. Ref-forwarded.

import React, { forwardRef, useId } from "react";
import { cx } from "./cx";

export const Textarea = forwardRef(function Textarea(
  { label, hint, error, id, className, invalid, ...props },
  ref
) {
  const reactId = useId();
  const inputId = id || reactId;
  const isInvalid = invalid || Boolean(error);

  const el = (
    <textarea
      ref={ref}
      id={inputId}
      className={cx("ds-input", "ds-textarea", className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    />
  );

  if (label == null && hint == null && error == null) return el;

  return (
    <div className="ds-field">
      {label != null && <label htmlFor={inputId}>{label}</label>}
      {el}
      {error != null ? (
        <div className="ds-field-err">{error}</div>
      ) : hint != null ? (
        <div className="ds-field-hint">{hint}</div>
      ) : null}
    </div>
  );
});

export default Textarea;
